const feedback = {
  path: 'feedback',
  component: resolve => require(['../../../../pages/user/course/feedback'], resolve)
}

export default feedback



// WEBPACK FOOTER //
// ./src/router/user/course/feedback/index.js